<template>
	<div>
		<div
			class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto my-auto bg-color--light--2"
		>
			<h3 class="text-center pt-3">
				{{ $t("contract.payment_noteBook") }}
			</h3>
			<h6 v-show="!showTable" class="pt-5 pb-10 text-center">
				هنوز پرداختی صورت نگرفته است.
			</h6>
			<vue-good-table
				:columns="columns"
				:rows="rows"
				:line-numbers="true"
				:rtl="true"
				:row-style-class="rowStyleClassFn"
				class="mt-3  pb-10 mr-0 ml-0 px-2 pt-1"
				v-show="showTable"
			>
				<template slot="table-row" slot-scope="props">
				
					<span v-if="props.column.field == 'date'">
						{{ props.row.date | moment("jYYYY/jMM/jD ") }}</span
					>

					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
				</template>
			</vue-good-table>
		</div>
	</div>
</template>


<script>
// import HeaderSuplier from "../components/shared/HeaderSuplier";
// import VueNumeric from "vue-numeric";
export default {
	props: ["id", "contract_id"],
	data() {
		return {
			

			columns: [
				{
					label: "تاریخ واریز",
					field: "date",
					tdClass: "text-center",
					thClass: "text-center",
                },
                {
					label: "مبلغ واریز",
					field: "amount",
					tdClass: "text-center",
					thClass: "text-center",
				}
				// {
				// 	label: "میزان معوقه",
				// 	field: "difference",
				// 	tdClass: "text-center",
				// 	thClass: "text-center",
				// },
				// {
				// 	label: "وضعیت",
				// 	field: "status",
				// 	tdClass: "text-center",
				// 	thClass: "text-center",
				// },
			],
			rows: []
		};
	},
	mounted() {
		
		this.getCustomerPayments();
		
	},
	computed: {
		showTable(){
			if((this.rows.length)==0){
				return false
			}
			else{
				return true
			}
		}
	},
	methods: {
		statusFn: function(st) {
			// if (st === "0") {
			// 	return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>پرداخت با تاخیر</b></span>';
			// }
			if (st === "1") {
				return '<span class="badge badge-success" style="height:25px;"><b>پرداخت شده</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-danger" style="height:25px;"><b> پرداخت نشده</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-secondary" style="height:25px;text-align:center"><b>موعد قسط نرسیده است</b></span>';
			}

			return;
		},
		actionBtn: function() {
			return '<button  @click.prevent="showContractDetail" type="button" class="btn btn-primary text-center font-w--400 " style="width:70px;height:35px;font-size: 0.75rem;">جزییات</button>';
		},
		rowStyleClassFn(row) {
			if (row.status === "0") {
				return "bg-warning";
			}
			if (row.status === "1") {
				return "bg-success";
			}
			if (row.status === "2") {
				return "bg-danger";
			}
			if (row.status === "3") {
				return "bg-light";
			}
		},
		// eslint-disable-next-line no-unused-vars
	
		// payStatusShow(st) {
		// 	if (st === "1") {
		// 		return '<span class="badge badge-succes" style="height:25px;"><b>خوش‌ حساب</b></span>';
		// 	}
		// 	if (st === "2") {
		// 		return '<span class="badge badge-warning" style="height:25px;"><b> پرداخت نا‌منظم</b></span>';
		// 	}
		// 	if (st === "3") {
		// 		return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>پرداخت پرخطر</b></span>';
		// 	}
		// },
		
		getCustomerPayments() {
			// console.log("props= ", this.id);

			this.$store
				.dispatch("getSuppliersCustomerPayments", this.contract_id)
				.then((resp) => {
					// (this.first_name = resp.body.first_name),
					// 	(this.last_name = resp.body.last_name),
					// 	(this.sign_date = resp.body.sign_date),
					// 	(this.invoice_date = resp.body.invoice_date),
					// 	(this.description = resp.body.description),
					// 	(this.net_amount = resp.body.net_amount),
					// 	(this.number_of_instalment = resp.body.number_of_instalment),
					// 	(this.downpayment = resp.body.downpayment),
					// 	(this.status = resp.body.status),
					// 	(this.supplier_name = resp.body.supplier_name),
					// 	(this.contract_id = resp.body.contract_id),
					// 	(this.vcc_number = resp.body.vcc_number),
					// 	(this.customer = resp.body.customer),
					// 	(this.customer_fullname = resp.body.customer_fullname),
					// 	(this.clearing_date = resp.body.clearing_date),
					// 	(this.instalment_amount = resp.body.instalment_amount),
					// 	(this.total_amount_of_instalments =
					// 		resp.body.total_amount_of_instalments),
					// 	(this.instalment_start_date = resp.body.instalment_start_date),
					// 	(this.end_date = resp.body.end_date),
					// 	(this.remaining_amount = resp.body.remaining_amount),
					// 	(this.debit_amount = resp.body.debit_amount),
					// 	(this.number_of_pays = resp.body.number_of_pays),
					// 	(this.instalment_detail = resp.body.instalment_detail);
					// this.pay_status = resp.body.pay_status;
					this.rows = resp.body.payments;
					console.log(resp)
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	components: {
		// VueNumeric,
	},
};
</script>

<style>